import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="bg-[#0a0a0a] py-24 relative overflow-hidden" data-id="element-28">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-full max-h-96 bg-[#d4a437]/10 blur-[100px] rounded-full pointer-events-none" data-id="element-29"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-30">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-[#111] border border-[#d4a437]/30 rounded-3xl p-8 md:p-16 text-center shadow-2xl" data-id="element-31">
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-8 leading-tight" data-id="element-32">
            Tu familia depende de tu capacidad de proveer, pero también de que
            estés con ellos. <br className="hidden md:block" data-id="element-33" />
            <span className="text-[#d4a437]" data-id="element-34">
              No elijas entre una cosa o la otra.
            </span>
          </h2>

          <p className="text-xl text-neutral-300 mb-12 font-serif italic" data-id="element-35">
            Construye tu ingreso invisible hoy.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8" data-id="element-36">
            <a href="https://d4chc.bemobtracks.com/click" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto inline-flex h-14 items-center justify-center rounded-md border border-white/20 bg-transparent px-8 text-base font-medium text-white transition-colors hover:bg-white/5 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-white" data-id="element-37">
              Acceso Gratuito
            </a>
            <a href="https://d4chc.bemobtracks.com/click" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto inline-flex h-14 items-center justify-center rounded-md bg-[#d4a437] px-8 text-base font-bold text-[#0a0a0a] transition-all hover:bg-[#b88c2e] hover:scale-[1.02] active:scale-[0.98] shadow-[0_0_20px_rgba(212,164,55,0.3)]" data-id="element-38">
              Planes de formación avanzada
            </a>
          </div>

          <p className="text-sm text-neutral-500" data-id="element-39">
            Comienza con el Acceso Gratuito o explora nuestros planes de
            formación avanzada.
          </p>
        </motion.div>
      </div>
    </section>;
}